module.exports = __webpack_public_path__ + "static/media/google-footer.19c94eb7.svg";